import Marquee from "react-fast-marquee";
import logo01 from "../../images/recognitions/1.png";
import logo02 from "../../images/recognitions/2.png";
import logo03 from "../../images/recognitions/3.png";
import logo04 from "../../images/recognitions/4.png";
import logo05 from "../../images/recognitions/5.png";
import logo06 from "../../images/recognitions/6.png";
import logo07 from "../../images/recognitions/7.png";

const BrandSection: React.FC = () => {
    return (
        <section className="brand pt-150 pb-50" >
            <div className="container-2xl">
                <div className="xb-brand-wrap xb-border">
                    <div className="brand-sub-title xb-border">
                        <p>
                            Recognized by
                            {/* <span> Top Companies</span> */}
                        </p>
                    </div>
                    <Marquee speed={40} gradient={false} pauseOnHover={false}>
                        <div className="brand-marquee marquee-left">
                            <div className="xb-brand-inner ul_li_between">
                                {[logo01, logo02, logo03, logo04, logo05, logo06, logo07].map(
                                    (logo, index) => (
                                        <div className="xb-brand-item" key={index} style={{ width: "200px", height: "150px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 30px" }}>
                                            <img src={logo} alt={`logo ${index + 1}`} style={{ objectFit: "contain", borderRadius: "10px", maxWidth: "180px", maxHeight: "150px" }} />
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </Marquee>

                </div>
            </div>
        </section>
    );
};

export default BrandSection;


